import React, { Component } from "react";
import "./PriceDiscovery.css";
import ReactPaginate from "react-paginate";
import $  from "jquery";
import OutsideClickHandler from "react-outside-click-handler";
import { Row, Col } from "react-bootstrap";
import { FiThumbsUp } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { Container } from "@mui/material";

// PriceDiscovery component 
class PriceDiscovery extends Component {
  constructor(props) {
    super(props);

    // Initialize component state
    this.state = {
      tenders: [],                 
      tendersFilter: [],            
      offset: 0,                  
      tensdersPageCount: 1,         
      perPage: 3,                  
      currentPage: 0,               
      checked: false,               
      postCategoryIdVlaue: "",       
      InitialAccessToken: localStorage.getItem("GlobalAccess"), 
      subCategoriesList: [],        
      copyOfTenders: [],           
      contentOwners: [],         
    };

    this.handlePageClick = this.handlePageClick.bind(this); // Bind pagination handler
    this.isComponentMounted = false; // Track component mount status to prevent setting state on unmounted components
  }

  // Lifecycle method - Fetch data after component mounts
  componentDidMount() {
    this.postCategoryIdValue(); // Fetch category ID and associated data
  }

  // Fetches post category ID and loads related content
  postCategoryIdValue() {
    this.isComponentMounted = true;
    fetch(`${window.appConfig.getContentCategories}${window.appConfig.Relam}${window.appConfig.Relam}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (!this.isComponentMounted) return; // Abort if component unmounted

        // Find the "ADVERTISEMENTS" category
        const postid = result.categoryList.filter(
          (data) => data.categoryname === "PRICE-DISCOVERY"
        );

        if (postid.length === 0) {
          console.warn("No matching category found");
          return;
        }

        const categoryId = postid[0].categoryid;

        // Fetch related content
        this.viewAllPriceDiscovery(categoryId);
        this.setState({ postCategoryIdValue: categoryId });
        this.adminsDropdownClick(categoryId);
        this.getCategorySubcategories(categoryId);
        this.ownerDropdownClick(categoryId);
      })
      .catch((err) => console.log("Fetch error:", err));
  }

  // Lifecycle method - Cleanup
  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  // Fetch tenders (content) based on category ID
  viewAllPriceDiscovery(postid) {
    fetch(`${window.appConfig.getContentList}${window.appConfig.Relam}category/${postid}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          copyOfTenders: result.contentList,
          tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
        });
      });
  }

  // Fetch content creators based on category ID for the dropdown filter
  adminsDropdownClick(catID) {
    fetch(`${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        const unique = [
          ...new Map(result.contentcreatorsList.map((data) => [data.contentcreatorid, data])).values(),
        ];
        this.setState({ tendersFilter: unique });
      })
      .catch((err) => console.log("err", err));
  }

  // Toggle organization dropdown visibility
  organizationsDropdownClick() {
    $("#dropdownPrice").toggle();
  }

  // Fetch tenders based on selected organization (creator)
  organizationsOnClick(Creator) {
    fetch(`${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdVlaue}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
        });
      })
      .catch((err) => console.log("err", err));

    $("#dropdownPrice").hide();
  }

  // Fetch subcategories related to category ID
  getCategorySubcategories(catID) {
    if (!catID) return;
    fetch(`${window.appConfig.getContentSubcategories}${window.appConfig.Relam}${window.appConfig.Relam}${window.appConfig.Relam}${catID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({ subCategoriesList: result.contentsubcategories });
      })
      .catch((err) => console.log("err", err));
  }

  // Toggle subcategories dropdown visibility
  subCategoriesDropdownClick() {
    $("#subCategoriesOfPrice").toggle();
  }

  // Filter tenders based on selected subcategory
  subCategoriesOnClick(subCategory) {
    const subCategoriesOfAdsFilter = this.state.copyOfTenders.filter((data) =>
      data.contentsubcategory.toLowerCase().includes(subCategory.toLowerCase())
    );

    this.setState({
      tenders: subCategoriesOfAdsFilter,
      tensdersPageCount: Math.ceil(subCategoriesOfAdsFilter.length / this.state.perPage),
    });

    $("#subCategoriesOfPrice").hide();
  }

  // Fetch content owners based on category ID
  ownerDropdownClick(catID) {
    fetch(`${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        const unique = [
          ...new Map(result.contentownerList.map((data) => [data.contentowner, data])).values(),
        ];
        this.setState({ contentOwners: unique });
      })
      .catch((err) => console.log("err", err));
  }

  // Toggle content owner dropdown visibility
  contentOwnerDropdownClick() {
    $("#ContentOwnerOfPrice").toggle();
  }

  // Fetch tenders for selected content owner
  getContentOwnerContent(Owner) {
    fetch(`${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdVlaue}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
        });
      })
      .catch((err) => console.log("err", err));

    $("#dropdownOrganizations").hide();
  }

  // Handle liking a piece of content
  likeCount(contentid) {
    fetch(`${window.appConfig.contentLikeCount}${window.appConfig.Relam}${contentid}`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
      .then((res) => res.text())
      .then((result) => {
        this.postCategoryIdValue(); // Refresh content after liking
        return NotificationManager.success(result); // Show success notification
      })
      .catch((err) => console.log("err", err));
  }

  /* Pagination handler */
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState({
      currentPage: selectedPage,
      offset: offset,
    });
  };
  /* End of pagination */



  render() {
    // Destructure state variables for easier access
    const { tenders, subCategoriesList, contentOwners } = this.state;
  
    // Slice the tenders list for pagination
    const priceDiscoveryList = tenders.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );
  
    return (
      <Container>
        <div
          id="tendersContainer"
          className="mb-lg-5 mb-4 mt-4 gbr-engage-container container-fluid"
        >
          {/* Title of the container */}
          <h3 className="container-title">Market Prices </h3>
  
          {/* Dropdown section for filtering */}
          <div className="mb-4">
            {/* Button to view all price discoveries */}
            <div className="dropdown">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  onClick={() =>
                    this.viewAllPriceDiscovery(this.state.postCategoryIdVlaue)
                  }
                >
                  All Price Discovery's
                </button>
              </div>
            </div>
  
            {/* Dropdown for filtering by Price Publisher */}
            <div className="dropdown">
              <div className="dropdown homepage-nav-item">
                <div className="navbarRight">
                  <button
                    className="btn btn-success homepageBtn"
                    type="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.organizationsDropdownClick()}
                  >
                    Price Publisher
                  </button>
                </div>
                <div
                  className="dropdown-menu"
                  id="dropdownPrice"
                  aria-labelledby="dropdownPrice"
                >
                  {this.state.tendersFilter &&
                    this.state.tendersFilter.map((filter, i) => (
                      <li key={i}>
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() =>
                            this.organizationsOnClick(filter.contentcreatorid)
                          }
                        >
                          {filter.contentcreatorid}
                        </a>
                      </li>
                    ))}
                </div>
              </div>
            </div>
  
            {/* Dropdown for filtering by Sub Categories */}
            <div className="dropdown">
              <div className="dropdown homepage-nav-item">
                <div className="navbarRight">
                  <button
                    className="btn btn-success homepageBtn"
                    type="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.subCategoriesDropdownClick()}
                  >
                    Sub Categories
                  </button>
                </div>
                <div
                  className="dropdown-menu"
                  id="subCategoriesOfPrice"
                  aria-labelledby="subCategoriesOfPrice"
                >
                  {subCategoriesList &&
                    subCategoriesList.map((filter, i) => (
                      <li key={i}>
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() =>
                            this.subCategoriesOnClick(
                              filter.contentsubcategoryname
                            )
                          }
                        >
                          {filter.contentsubcategoryname}
                        </a>
                      </li>
                    ))}
                </div>
              </div>
            </div>
  
            {/* Dropdown for filtering by Market (Content Owner) */}
            <div className="dropdown">
              <div className="dropdown homepage-nav-item">
                <div className="navbarRight">
                  <button
                    className="btn btn-success homepageBtn"
                    type="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.contentOwnerDropdownClick()}
                  >
                    Markets
                  </button>
                </div>
                <div
                  className="dropdown-menu"
                  id="ContentOwnerOfPrice"
                  aria-labelledby="ContentOwnerOfPrice"
                >
                  {contentOwners &&
                    contentOwners.map((filter, i) => (
                      <li key={i}>
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() =>
                            this.getContentOwnerContent(
                              filter.contentowner
                            )
                          }
                        >
                          {filter.contentowner}
                        </a>
                      </li>
                    ))}
                </div>
              </div>
            </div>
          </div>
  
          {/* Display the list of price discovery items */}
          <div className="adminTendersDiv">
            {/* Check if there are price discovery items */}
            {priceDiscoveryList.length !== 0 ? (
              <Row className="justify-content-center">
                {/* Map through the price discovery list and display each item */}
                {priceDiscoveryList.map((tend, index) => (
                  <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                    <div className="community-cards w-100">
                      <div className="bordered-div"></div>
                      <div className="pb-2">
                        <div className="scrollable-container">
                          <div className="community-card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                              <span className="d-block">
                                {tend.contentsubcategory}
                              </span>
                              {/* Like button and count */}
                              <p className="products-like mb-0 d-flex align-items-end">
                                <span
                                  className="d-inline-block"
                                  onClick={() => {
                                    this.likeCount(tend.contentid);
                                  }}
                                >
                                  <FiThumbsUp size={30} />
                                </span>
                                <small>{tend.likecount}</small>
                              </p>
                            </div>
  
                            {/* Display the content name and timestamp */}
                            <h2 className="mb-0">{tend.contentname}</h2>
                            <h5 className="mb-2">
                              Posted by <span>{tend.contentcreatorid}</span>,{" "}
                              {tend.timestamp}
                            </h5>
  
                            {/* Display content description with a link */}
                            <a
                              className="text-decoration-none"
                              href={tend.texturl}
                              target="_blank"
                            >
                              <h6 className="mb-3">{tend.contentdescription}</h6>
                            </a>
                          </div>
                        </div>
                      </div>
                      {/* Download button for the document */}
                      <div className="community-button-container p-3 px-0 text-center mt-2">
                        <a
                          className={`${
                            tend.locationurl
                              ? "downloadDocument mt-0 "
                              : "downloadDocument mt-0 disabledBtn"
                          }`}
                          href={tend.locationurl}
                          download
                        >
                          Download Document
                        </a>
                      </div>
                    </div>
                  </Col>
                ))}
                {/* Pagination component */}
                <div className="paginationComponent">
                  <ReactPaginate
                    previousLabel={"<<"}
                    nextLabel={">>"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={this.state.tensdersPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              </Row>
            ) : (
              // Message when no price discovery items are found
              <div className="card">
                <p className="card-body container-heading2">
                  <b>Price Discovery's Not Found</b>
                </p>
              </div>
            )}
          </div>
  
          {/* Handle outside click to close dropdowns */}
          <OutsideClickHandler
            onOutsideClick={() => {
              $("#dropdownPrice").hide();
              $("#subCategoriesOfPrice").hide();
              $("#ContentOwnerOfPrice").hide();
            }}
          ></OutsideClickHandler>
        </div>
      </Container>
    );
  }
  
}

export default PriceDiscovery;
